// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__RqhVP","rootCenter":"LoadMoreObserver_rootCenter__o9_yQ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1qqCY"};